import './styles.scss'

import { Col, Row } from 'antd'

import { displayTypes } from './block-two-col.constants'

const defaultColProps = { xs: 24, lg: 12 }

interface BlockTwoColProps {
  className?: string
  left: React.ReactNode
  right: React.ReactNode
  type?: number
}

function BlockTwoCol({
  className,
  left,
  right,
  type = displayTypes.REVERSE,
}: BlockTwoColProps) {
  const leftProps = type === displayTypes.REVERSE
    ? { xs: 24, lg: { order: 0, span: 12 }, order: 1 }
    : defaultColProps
  const rightProps = defaultColProps

  return (
    <div className={`block-two-col ${className}`}>
      <Row gutter={[24, 24]}>
        <Col {...leftProps}>{left}</Col>
        <Col {...rightProps}>{right}</Col>
      </Row>
    </div>
  )
}

export default BlockTwoCol
